import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { BreadcrumbItem, buildBreadcrumbsForPath } from '@/config/navigation';

interface AppBreadcrumbsProps {
  items?: BreadcrumbItem[];
  labelOverrides?: Partial<Record<string, string>>;
  className?: string;
}

export const AppBreadcrumbs: React.FC<AppBreadcrumbsProps> = ({ items, labelOverrides, className }) => {
  const location = useLocation();
  const rawBreadcrumbs = items ?? buildBreadcrumbsForPath(location.pathname, labelOverrides);
  const breadcrumbs = rawBreadcrumbs.filter((item, index, array) => {
    const isIntermediate = index > 0 && index < array.length - 1;
    const isCelebrationsNode = item.label.trim().toLowerCase() === 'celebrations';
    return !(isIntermediate && isCelebrationsNode);
  });

  if (!breadcrumbs.length) {
    return null;
  }

  return (
    <nav className={`flex items-center text-xs text-muted-foreground ${className ?? ''}`.trim()} aria-label="Breadcrumb">
      {breadcrumbs.map((item, index) => {
        const isLast = index === breadcrumbs.length - 1;
        return (
          <React.Fragment key={`${item.label}-${index}`}>
            {item.to && !isLast ? (
              <Link to={item.to} className="hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-sm">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? 'font-medium text-foreground' : undefined}>{item.label}</span>
            )}
            {!isLast && <ChevronRight className="h-3 w-3 mx-1" />}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
